import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VueAnalytics from 'vue-analytics'
import VueMultianalytics from 'vue-multianalytics'
import VueGtm from 'vue-gtm'
import App from '@/App'
import router from '@/router'
import store from '@/store'

Vue.use(Vuelidate)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

Vue.use(VueAnalytics, {
  id: 'G-KP5NW575TK',
  router
})

const mixpanelConfig = {
  token: '111e68349315c1b2bd98298dcd23634b'
}

Vue.use(VueMultianalytics, {
  modules: {
    mixpanel: mixpanelConfig
  },
  routing: {
    vueRouter: router
  }
})

Vue.use(VueGtm, {
  id: 'GTM-WLZ2CPL',
  enabled: true,
  debug: false,
  vueRouter: router
})

router.afterEach(function (to, from) {
  if (to.name === 'Home' && from.name === 'RequestDetail') {
    if (store.state.comesFromComparison === false) {
      store.state.creditstocompare = []
      store.state.comesFromComparison = false
    }
  } else if (to.name !== 'RequestDetail') {
    store.state.creditstocompare = []
    store.state.comesFromComparison = false
  }
})



// WEBPACK FOOTER //
// ./src/main.js